import React, { useContext, useEffect, useState } from 'react';

import JobDatasheetLanguageContext from 'src/components/JobDatasheet/context/JobDatasheetLanguageContext';
import { QuestionWithAttachmentsPropTypes } from 'src/components/JobDatasheet/propTypes';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';
import { prepareRuleAndGetExclusive } from './utils';

export const QuestionWithAttachments = (props) => {
  const {
    isRectifiedQuestion,
    onChange,
    label,
    isSurvey = true,
    question: {
      pictureSettings,
      voiceSettings,
      questionType,
      translations,
      validations,
    },
    value,
    disableChange,
  } = props;

  const questionSettings = questionType === 'picture' ? pictureSettings : voiceSettings;
  const { allowMultiSelect, options } = questionSettings;
  const { selectedLanguage } = useContext(JobDatasheetLanguageContext);
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';

  const [multiSelectValues, setMultiSelectValues] = useState(value ? value[selectedValueKey] : []);

  const [exclusive, setExclusive] = useState([]);
  useEffect(() => {
    setExclusive((validations || []).reduce((accu, { rule }) => [
      ...accu,
      ...prepareRuleAndGetExclusive(rule).exclusive,
    ], []));
  }, [validations]);
  const valueArray = Array.isArray(value?.value) ? value.value : [value?.value];
  const isExclusiveSelected = valueArray.some(c => exclusive.includes(c));

  useEffect(() => {
    if (!isSurvey) {
      setMultiSelectValues(value ? value[selectedValueKey] : []);
    }
  }, [value, isSurvey]);

  const onCheckboxChange = (event, index) => {
    if(event.target.checked) {
      const isExclusiveIndex = exclusive.includes(index);
      const updatedMultiSelectValues = [...(isExclusiveIndex ? [] : multiSelectValues), index];
      const uniqueMultiSelectValues = [...new Set(updatedMultiSelectValues)];
      setMultiSelectValues(uniqueMultiSelectValues);
    } else {
      const updatedMultiSelectValues = multiSelectValues.filter(val => val !== index);
      setMultiSelectValues(updatedMultiSelectValues);
    }
  };

  const getTranslatedOptions = () => {
    if (!selectedLanguage) {
      return options.map(v => ({label: v.label }));
    }

    const optionsTranslations = (translations || []).find(c => c.languageId === selectedLanguage)?.options;

    return optionsTranslations ? 
      optionsTranslations.map(v => ({label: v})) : 
      options.map(v => ({label: v.label }));
  };

  const getReturnObject = (selectedValue) => {
    if(Array.isArray(selectedValue) && !selectedValue.length) {
      return null;
    }
    
    const returnObject = {
      ...value,
      type: questionType,
    };

    returnObject[selectedValueKey] =  selectedValue;

    return returnObject;
  };

  const displayLabelIfSurvey = (index) => {
    if (isSurvey) {
      return <s.PictureLabelText>{String.fromCharCode(index + 65)}</s.PictureLabelText>;
    }
    return null;
  }

  useEffect(() => {
    if (allowMultiSelect) {
      const returnObject = getReturnObject(multiSelectValues);
      onChange(returnObject);
    }
  }, [JSON.stringify(multiSelectValues)]);

  const optionTranslations = getTranslatedOptions();
  const onAudioPlaying = (e) =>{
    const audios = document.getElementsByTagName('audio');
    /*  eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]  */
    for (let i = 0, len = audios.length; i < len; i++) {
        if (audios[i] !== e.target) {
            audios[i].pause();
        }
    }

  }
  const audioQuestion = (option, index) => {
    return <s.AttachmentWrapper audio>
    { questionType !== 'picture' && (
        isSurvey && option.fileId && (
            <s.AttachmentText key={index}> 
              <audio src={option.fileUrl} controls  onPlaying={onAudioPlaying}></audio>
            </s.AttachmentText>
          )
        )}
    </s.AttachmentWrapper>
  }
  return (
    <>
      <s.AttachmentWrapper>
        { questionType === 'picture' && options.map((option, index)=> {
          return (
           isSurvey && option.fileUrl && (
              <s.AttachmentText key={index}>
                <label>{String.fromCharCode(index + 65)}</label>
                <img src={option.fileUrl} />
              </s.AttachmentText>)
            )
        })
      }
      </s.AttachmentWrapper>
      <s.AttachmentOptionWrapper>
        { allowMultiSelect ?
          options.map((option, index) => {
            const checked = (multiSelectValues || []).includes(index) ? 'checked' : false;

            return (
              <s.AttachmentWrapperText key={index} >
                <s.AttachmentOptionContainer>
                  <s.AttachmentCheckboxWrapper 
                    disabled={!checked && isExclusiveSelected}
                    type="checkbox"
                    checked={checked}
                    onChange={!disableChange && ((e) => onCheckboxChange(e, index))}
                    value={multiSelectValues}
                  />
                   { questionType === 'picture' && displayLabelIfSurvey(index) } 
                  <s.AttachmentOptionText>{ optionTranslations[index]?.label}</s.AttachmentOptionText>
                </s.AttachmentOptionContainer>
                {audioQuestion(option, index)}
              </s.AttachmentWrapperText>
          )}) : 
          options.map((option, index) => {
            return ( 
              <s.AttachmentWrapperText key={index} >
                <s.AttachmentOptionContainer>  
                  <s.RadioGroupInput
                    type="radio"
                    checked={value?.value === index ? 'checked' : false}
                    onChange={e => onChange(getReturnObject(index))}
                    value={value?.value || ''}
                  />
                 { questionType === 'picture' && displayLabelIfSurvey(index) } 
                 <s.AttachmentOptionText>{optionTranslations[index]?.label}</s.AttachmentOptionText>
                </s.AttachmentOptionContainer>
                {audioQuestion(option, index)}               
              </s.AttachmentWrapperText>
          )})
        }
      </s.AttachmentOptionWrapper>
    </>
  );
};

QuestionWithAttachments.propTypes = QuestionWithAttachmentsPropTypes;